import React from 'react'

const SalesReturns = () => {
  return (
    <div>SalesReturns</div>
  )
}

export default SalesReturns